const token = () => {
  const tokenElement = document.getElementsByName('csrf-token')[0];
  if (tokenElement) {
    return tokenElement.content;
  }
  return null;
};

export default token();
